import script from "./MyHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MyHome.vue?vue&type=script&setup=true&lang=js"

import "./MyHome.vue?vue&type=style&index=0&id=7a42dc94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a42dc94"]])

export default __exports__